import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchUser } from '@/api/users';

/** Everything under this prefix — what a write invalidates. */
export const userDetailQueryKey = ['users', 'detail'] as const;

/** Shared with the route loader that prefetches this page. */
export function userDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: [...userDetailQueryKey, id] as const,
    queryFn: () => fetchUser(id),
  });
}

export function useUserDetail(id: string) {
  const query = useQuery(userDetailQueryOptions(id));

  return {
    user: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    // Passed to `QueryErrorState`, which reads the status off it — a colleague
    // at another company gets a 403 here, and "you don't have access" is the
    // honest message for that rather than a generic failure.
    error: query.error,
  };
}
